import { type ReactElement } from 'react';

export const SessionsListItem = ({
  label,
  value,
}: {
  label: string;
  value: string | number;
}): ReactElement => (
  <li className="text-md text-denim-600">
    <span className="text-sm text-gray-500 mr-1">{label}</span>
    <span className="text-md text-denim-600 font-medium">{value}</span>
  </li>
);
